import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio2To112(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMediaObjectRatio2To112"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#MediaObjectRatio2To112)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M1.5 2h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5M0 2.5A1.5 1.5 0 0 1 1.5 1h4A1.5 1.5 0 0 1 7 2.5v7A1.5 1.5 0 0 1 5.5 11h-4A1.5 1.5 0 0 1 0 9.5zm9 0a.5.5 0 0 1 .5-.5h2.002a.5.5 0 1 1 0 1H9.5a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h2.002a.5.5 0 1 1 0 1H9.5a.5.5 0 0 1-.5-.5M9.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zM9 8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="MediaObjectRatio2To112">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconMediaObjectRatio2To112);
